import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { SpendLogV2Entry } from '@litellm-ui/shared';

export type LogRow = SpendLogV2Entry & {
  timestamp?: string | null;
  cost?: number | null;
  latency_ms?: number | null;
  status?: 'success' | 'error' | null;
};

/**
 * Fetch a single log row by request_id.
 *
 * Upstream /spend/logs/v2 requires start_date and end_date even when
 * filtering by request_id. The worker defaults to today UTC when not
 * provided, so logs from other days will not be found unless the caller
 * passes the matching date range via `range`.
 */
export function useLogDetail(
  requestId: string | undefined,
  range?: { start_date?: string; end_date?: string },
) {
  return useQuery({
    queryKey: ['log-detail', requestId, range?.start_date, range?.end_date],
    queryFn: () =>
      api<LogRow>(`/api/logs/${encodeURIComponent(requestId ?? '')}`, {
        query: range,
      }),
    enabled: !!requestId,
    retry: false,
  });
}